import { render, staticRenderFns } from "./AfterSalesAdd.vue?vue&type=template&id=3fbb4652&"
import script from "./AfterSalesAdd.vue?vue&type=script&lang=js&"
export * from "./AfterSalesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports